export const CHOICE_QUESION_TYPE = 'App\\ChoiceQuestion';
export const PICTURE_QUESION_TYPE = 'App\\PictureQuestion';
export const COUNT_LANGUAGES = 2;
export const COUNT_CHOICE_QUESTION_ANSWER = 4; // 1,2,3,4
export const MIN_COUNT_PICTURE_QUESION_ANSWER = 2; // 0,1
export const COUNT_PICTURE_QUESION_ANSWER = 5; // 0,1,2,3,4

export const COUNT_PICTURES = 1;

export const USER_ROLE_ADMIN = 1;
export const USER_ROLE_MANAGER = 2;
export const USER_ROLE_TEACHER = 3;
export const USER_ROLE_STUDENT = 4;

export const USER_STATUS_DISABLED = 0;
export const USER_STATUS_ENABLED = 1; // if school is blocked

export const USER_STATUS_UNLOCKED = 0;
export const USER_STATUS_LOCKED = 1;

export const USER_TOPIC_STATUS_STARTED = 1;
export const USER_TOPIC_STATUS_FINISHED = 2;

export const USER_LESSON_STATUS_STARTED = 1;
export const USER_LESSON_STATUS_FINISHED = 2;

export const USER_COURSE_STATUS_FINISHED = 2;

export const QUIZ_STATUS_FAILED = 1;
export const QUIZ_STATUS_PASSED = 2;

export const EMAIL_TEMPLATE_FINISH_LESSON = 1;
export const EMAIL_TEMPLATE_FINISH_COURSE = 2;
export const EMAIL_TEMPLATE_START_COURSE = 3;

export const COOKIE_TYPE_ADMIN = 'admin';



// WEBPACK FOOTER //
// ./src/utils/constants.js